module.exports = __webpack_public_path__ + "static/media/templates-trivvy.57b06391.png";